module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "revolution"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/5TOC#rev"
    }
  }, [_vm._v("REVOLUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("Of course, the entire effort is to put oneself")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("Outside the ordinary range")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("Of what are called statistics.")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("STEPHEN SPENDER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4075d232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/10-revolution.vue
// module id = 90
// module chunks = 0